var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "MapSettingsMenu",
        "content-class": "menu-bg-blue-transparent-modal",
        title: "Map Settings",
        "hide-footer": "",
      },
      on: {
        show: function ($event) {
          return _vm.getMapSettings()
        },
      },
    },
    [
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            { staticClass: "p-1 m-3" },
            [
              _c(
                "label",
                {
                  staticClass: "col-sm-4 col-form-label",
                  attrs: { for: "extents" },
                },
                [_vm._v("\n        Default Extent\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "col-sm-8" },
                [
                  _c(
                    "b-form-select",
                    {
                      staticStyle: { "text-shadow": "0px 0px" },
                      attrs: { id: "extents" },
                      model: {
                        value: _vm.selectedExtent,
                        callback: function ($$v) {
                          _vm.selectedExtent = $$v
                        },
                        expression: "selectedExtent",
                      },
                    },
                    _vm._l(_vm.extents, function (extent) {
                      return _c(
                        "b-form-select-option",
                        { key: extent.id, attrs: { value: extent } },
                        [_vm._v(_vm._s(extent.extent_description))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "p-3" },
            [
              _c(
                "b-col",
                { staticClass: "text-center" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", size: "lg", type: "submit" },
                      on: {
                        click: function ($event) {
                          return _vm.saveMapSettings()
                        },
                      },
                    },
                    [_vm._v("\n          Save\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }